import { Directive, Input, OnInit, inject } from '@angular/core';

import { ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsTabsGroup } from '@frontend/ui/tabsgroup';

import { ThemeIndicator, ThemeSize, ThemeVariant } from './types';

@Directive({
    selector: '[msThemedTabs]',
})
export class SportsThemedTabsDirective implements OnInit {
    @Input() themedIndicator?: ThemeIndicator;
    @Input() themedSize?: ThemeSize;
    @Input() themedVariant?: ThemeVariant;
    @Input() themedInverse?: ThemeInverse;
    currentTheme = injectCurrentTheme();
    tabGroup: DsTabsGroup = inject(DsTabsGroup, {
        self: true,
    });

    ngOnInit(): void {
        const indicator = this.themedIndicator?.[this.currentTheme];
        if (indicator) {
            this.tabGroup.indicator.set(indicator);
        }

        const variant = this.themedVariant?.[this.currentTheme];
        if (variant) {
            this.tabGroup.variant.set(variant);
        }

        const size = this.themedSize?.[this.currentTheme];
        if (size) {
            this.tabGroup.size.set(size);
        }

        const inverse = this.themedInverse?.[this.currentTheme];
        if (inverse) {
            this.tabGroup.inverse.set(inverse.isInverse);
        }
    }
}
